const schemePrefix = {
  NAVER_APP: 'naverapp://',
}

enum Type {
  CLOSE_WINDOW = 'CLOSE_WINDOW',
}

const Path = {
  [Type.CLOSE_WINDOW]: 'closewindow',
}

function getScheme({ type }: { type: Type }): string {
  return `${schemePrefix.NAVER_APP}${Path[type]}`
}

const nApp = {
  Type,
  Path,
  getScheme,
  schemePrefix,
}

export default nApp
